module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © 2005 by John Wiley & Sons, Inc. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Published by Jossey-Bass")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("A Wiley Imprint")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("989 Market Street, San Francisco, CA 94103-1741 "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.josseybass.com",
      "target": "_blank"
    }
  }, [_vm._v("www.josseybass.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Except as specifically noted below, no part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, scanning, or otherwise, except as permitted under Section 107 or 108 of the 1976 United States Copyright Act, without either the prior written permission of the publisher, or authorization through payment of the appropriate per-copy fee to the Copyright Clearance Center, Inc., 222 Rosewood Drive, Danvers, MA 01923, 978-750-8400, fax 978-646-8600, or on the Web at "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.copyright.com",
      "target": "_blank"
    }
  }, [_vm._v("www.copyright.com")])]), _vm._v(". Requests to the publisher for permission should be addressed to the Permissions Department, John Wiley & Sons, Inc., 111 River Street, Hoboken, NJ 07030, 201-748-6011, fax 201-748-6008, or online at "), _c('span', {
    staticClass: "inlineurl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.wiley.com/go/permissions",
      "target": "_blank"
    }
  }, [_vm._v("http://www.wiley.com/go/permissions")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The materials contained on the accompanying CD-ROM are designed for use in a group setting and may be reproduced for educational/training purposes. The reproducible pages are designated on the CD-ROM by the appearance of the following copyright notice at the foot of each page:")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Advanced Facilitation Strategies")]), _vm._v(" © 2005 Ingrid Bens and John Wiley & Sons, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("This notice may not be changed or deleted and it must appear on all reproductions as printed.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("This free permission is limited to limited customization of the CD-ROM materials for your organization and the paper reproduction of the materials for educational/training events. Systematic or large-scale reproduction or distribution (more than one hundred copies per year) or inclusion of items in publications for sale may be done only with prior written permission of the publisher. Also, reproduction on computer disk or by any other electronic means requires prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The material on the CD-ROM is provided “as is.” Neither the author of the material nor the publisher makes any warranties of any kind, express or implied, regarding either the functionality or the contents. Neither the author nor the publisher assume any responsibility for errors or omissions or damages, including any incidental, special, or consequential damages. To the fullest extent permissible by law, the publisher disclaims all warranties of merchantability and fitness for a particular purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Limit of Liability/Disclaimer of Warranty: While the publisher and author have used their best efforts in preparing this book, they make no representations or warranties with respect to the accuracy or completeness of the contents of this book and specifically disclaim any implied warranties of merchantability or fitness for a particular purpose. No warranty may be created or extended by sales representatives or written sales materials. The advice and strategies contained herein may not be suitable for your situation. You should consult with a professional where appropriate. Neither the publisher nor author shall be liable for any loss of profit or any other commercial damages, including but not limited to special, incidental, consequential, or other damages.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Jossey-Bass books and products are available through most bookstores. To contact Jossey-Bass directly call our Customer Care Department within the U.S. at 800-956-7739, outside the U.S. at 317-572-3986, or fax 317-572-4002.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Jossey-Bass also publishes its books in a variety of electronic formats. Some content that appears in print may not be available in electronic books.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Bens, Ingrid.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Advanced facilitation strategies : tools & techniques to master difficult situations / Ingrid Bens.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Includes bibliographical references.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN-13: 978-0-7879-7730-6 (alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN-10: 0-7879-7730-6 (alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("1. Teams in the workplace. 2. Group facilitation. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("HD66.B4448 2005")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("658.4'022—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("2005010922")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24e47656","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Copyright.vue
// module id = 63
// module chunks = 0